// extracted by mini-css-extract-plugin
export default {"header":"WorkflowHeader_header__jQimF","icon":"WorkflowHeader_icon__XU3+o","title":"WorkflowHeader_title__aaKJR","loading-value":"WorkflowHeader_loading-value__sGupm"};